<template>
    <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="mt-3 mb-3 w-100 grid grid-cols-5 justify end">
                    <div class="col-end-6">
                        <label class="block text-sm font-medium leading-5 text-gray-700">
                            {{$t('message.datatableinteractive.busqueda')}}
                        </label>
                        <div class="mt-1 rounded-md shadow-sm">
                            <input v-model="wordToSearch" @input="searchWord" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                        </div>
                    </div>
                </div>
                <div class="shadow overflow-hidden border-b border-gray-200">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th v-for="header in headers" :key="header.title" @click="header.data ? sortTable(header) : () => {}" :class="header.data ? 'cursor-pointer' : ''" class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    {{ header.title }}
                                    <svg v-if="sortHeader.data === header.data && sortOrientation === 1" height="15px" width="15px" class="inline-block" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512"  xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6  c1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z"/></svg>
                                    <svg v-else-if="sortHeader.data === header.data && sortOrientation === -1" height="15px" width="15px" class="inline-block" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M413.1,327.3l-1.8-2.1l-136-156.5c-4.6-5.3-11.5-8.6-19.2-8.6c-7.7,0-14.6,3.4-19.2,8.6L101,324.9l-2.3,2.6  C97,330,96,333,96,336.2c0,8.7,7.4,15.8,16.6,15.8v0h286.8v0c9.2,0,16.6-7.1,16.6-15.8C416,332.9,414.9,329.8,413.1,327.3z"/></svg>
                                    <svg v-else-if="header.data" height="20px" width="20px" class="inline-block" style="enable-background:new -265 388.9 64 64;" version="1.1" viewBox="-265 388.9 64 64" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M-245.9,420.1l13.2-13c0.3-0.3,1.1-0.3,1.4,0l13.2,13c0.3,0.3-0.1,0.7-0.7,0.7h-26.4C-245.8,420.8-246.2,420.4-245.9,420.1   z"/><path d="M-245.9,425.7l13.2,13c0.3,0.3,1.1,0.3,1.4,0l13.2-13c0.3-0.3-0.1-0.7-0.7-0.7h-26.4C-245.8,425-246.2,425.4-245.9,425.7z"/></g></svg>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="d in viewData" :key="d.id">
                                <td v-for="header in headers" :key="`${d.id}-${header.title}`" class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                                    <span v-if="header.render" v-html="header.render(d)"> </span>
                                    <template v-else-if="header.data"> {{d[header.data]}} </template>
                                    <span v-else-if="header.actions" class="relative z-0 inline-flex shadow-sm rounded-md">
                                        <button v-for="(action, index) in header.actions" :key="index" type="button" :class="action.className" @click="action.action(d)" class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                                            {{ action.text }}
                                        </button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'data-table-interactive',
    data(){
        return {
            sortOrientation: 0,
            sortHeader: {},
            viewData: [], //Data in view
            processedData: [], //Data processed,
            wordToSearch: ''
        }
    },
    props: {
        headers: {
            type: Array,
            required: true
        },
        data: {
            type: Array,
            required: true
        }
    },
    computed: {
        headersToSearch(){
            return this.headers.filter(item => !!item.data);
        }
    },
    methods: {
        sortTable(header, change=true){ //Sort is for view Data
            if (change) this.sortOrientation = this.sortHeader.data === header.data && this.sortOrientation === 1 ? -1 : 1;

            this.viewData = this.viewData.sort((a, b) => {
                let first, second;
                switch(header.type){
                    case Number:
                        first = Number(a[header.data]);
                        second = Number(b[header.data]);
                        break;
                    default:
                        first = a[header.data] ? a[header.data].toString().toLowerCase() : '';
                        second = b[header.data] ? b[header.data].toString().toLowerCase() : '';
                        break;
                }
                return first > second ? this.sortOrientation : (first < second ? -this.sortOrientation : 0)
            });
            this.sortHeader = header;
        },
        searchWord(){ //Search is for proccessed data
            const newValue = this.wordToSearch.toLowerCase();
            let indexes = [];
            this.processedData.forEach((data, index) => {
                if (this.headersToSearch.some(header => data[header.data].includes(newValue)))
                    indexes.push(index);
            });
            this.viewData = indexes.map(index => ({...this.data[index]}));
            this.sortTable(this.sortHeader, false)
        },
        initTable(){
            this.searchWord();
            this.sortTable(this.sortHeader, false);
        }
    },
    watch: {
        data(){ // When change or loading data
            this.viewData = [...this.data];
            this.processedData = this.data.map(d => Object.assign({...d}, ...this.headersToSearch.filter(header => 
                    header.transform
                ).map(header => ({[header.data]: header.transform(d)})))
            );
            this.processedData = this.processedData.map(d => Object.assign({...d}, ...this.headersToSearch.map(header => ({[header.data]: d[header.data] ? d[header.data].toString().toLowerCase() : ''}))));
            this.initTable()
        }
    }
}
</script>
